import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import FooterOne from "../../components/Footer/FooterOne";
import CTAOne from "../../components/CTA/CTAOne";




const ResponsiveIframe = () => {
  // const home = useRef();
  // const about = useRef();
  // const sales = useRef();
  // const service = useRef();
  // const agents = useRef(); 
  // const rentals = useRef();
  // const contact = useRef();

  // const scrollToSection = (e, content) => {
  //   e.preventDefault();
  //   switch (content) {
  //     case "home":
  //       home.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     case "about":
  //       about.current.scrollIntoView({ behavior: "smooth" });
  //         break;
  //     case "sales":
  //       sales.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     case "service":
  //       service.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     case "agents":
  //       agents.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     case "rentals":
  //       rentals.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     case "contact":
  //       contact.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     default:
  //   }
  // };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Loader>
      <HeaderOne  />
      <section className="">
      <div className="container my-5">
              <h2>Olshan in the Press - Archive</h2>
              </div>
       <br />
      <div style={{ position: 'relative', paddingBottom: '55%', paddingTop: '10%', height: 0 }}>
    <iframe
      src={`${process.env.REACT_APP_IFRAME_BASE_URL}press_2FRAME.php`}
      title="OLSHAN PRESS ARCHIVE"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 0
      }}
      allowFullScreen
    />
  </div>

    
    </section>

    <CTAOne
            tagline="Olshan Luxury Report"
            title="Highly focused. Data Driven."
            textButton="GET THE LATEST LUXURY REPORT"
            linkButton="/market-report"
            bg="color"
          >
            This report is the only one of its kind. On a weekly basis, Olshan
            publishes a report covering all the contract activity in the luxury
            market on properties at $4 million and above.
          </CTAOne>


      <FooterOne />
    </Loader>
  );
};



export default ResponsiveIframe;










